module.exports = __webpack_public_path__ + "static/brascol-expobaby-63d0981765c872aad3cb9744dc200e52.jpg";